import Bugsnag from '@bugsnag/js'

// Check if we are in a production runtime environment
const isProdRuntime =
  process.env.NEXT_PHASE !== 'phase-production-build' && process.env.NODE_ENV === 'production'

/**
 * Starts Bugsnag if we are in a production runtime environment,
 * and sets up the appropriate plugins.
 */
export const start = async () => {
  if (isProdRuntime && process.env.BUGSNAG_API_KEY) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const plugins: any[] = []

    /**
     * We only want to include the @bugsnag/plugin-aws-lambda plugin if we are on the server.
     * This is because this plugin only works when we are using AWS Lambda.
     */
    if (process.env.NEXT_IS_SERVER) {
      plugins.push(await import('@bugsnag/plugin-aws-lambda'))
    }

    Bugsnag.start({
      apiKey: process.env.BUGSNAG_API_KEY,
      appVersion: `${process.env.APP_ENV}-${process.env.NEXT_BUILD_ID}`,
      releaseStage: process.env.APP_ENV,
      plugins,
    })
  }
}

/**
 * Returns the Bugsnag plugin for use with AWS Lambda functions.
 */
export const getServerlessHandler = () => Bugsnag.getPlugin('awsLambda')?.createHandler()
